import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'styled-theming';
import { Box } from 'rebass/styled-components';

const borderColor = theme.variants('mode', 'variant', {
  default: {
    light: (props) => (props.isEditing ? props.theme.colors.superLightGrey : 'transparent'),
    dark: 'transparent',
  },
  error: {
    light: (props) => props.theme.colors.deepOrange,
    dark: (props) => props.theme.colors.orange,
  },
});

const innerBackgroundColor = theme('mode', {
  light: (props) => props.theme.colors.ghostDark,
  dark: (props) => props.theme.colors.lpGhost,
});

const Container = styled(Box)`
  border-radius: ${(props) => props.theme.radius.small};
  border-width: ${(props) => (props.theme.mode === 'light' ? 1 : 0)};
  border-style: solid;
  border-color: ${borderColor}};
`;

const InnerContainer = styled(Box)`
  border: 1px solid ${(props) => (props.isEditing ? borderColor : 'transparent')};
  border-radius: ${(props) => props.theme.radius.medium};
  background-color ${innerBackgroundColor};
`;

function EditorContainer(props) {
  const {
    variant, isEditing, ...otherProps
  } = props;

  switch (variant) {
    case 'inner':
      return <InnerContainer isEditing={isEditing} {...otherProps} />;
    default:
      return <Container isEditing={isEditing} {...otherProps} />;
  }
}

EditorContainer.defaultProps = {
  isEditing: false,
  variant: undefined,
};

EditorContainer.propTypes = {
  isEditing: PropTypes.bool,
  variant: PropTypes.string,
};

export default EditorContainer;
